import { Link } from 'react-router-dom';
import type { Environment } from '../../api';
import { Callout } from '../primitives';

/** isOperatedOverSSH: the environment's records live in the SSH engine. */
export function isOperatedOverSSH(environment: Environment | null | undefined, isWordPress = false): boolean {
  return Boolean(environment) && environment!.deployment_mode === 'existing_atomic' && !isWordPress;
}

/**
 * SSHEnvironmentNotice says, where a section would otherwise show an empty
 * list, that an SSH environment keeps these records on its own page (UX-08):
 * never "Nothing deployed yet" or "No backup" for a store that has both.
 */
export function SSHEnvironmentNotice({ environment, what }: { environment: Environment; what: string }) {
  return (
    <Callout
      tone="info"
      title={`${environment.name} is operated over SSH`}
      testId="ssh-environment-notice"
      actions={
        <Link className="button button--secondary button--small" to={`/app/environments/${environment.id}`}>
          Open the environment page
        </Link>
      }
    >
      {what} of this environment are run by the SSH engine and shown on its environment page, not here.
    </Callout>
  );
}
